export default __webpack_public_path__ + "static/media/honey_coins_indicator_icon.f6ca54f8.svg";